<template>
  <div class="div_header">
    <div class="layout fix_position">
      <div class="header_login_info" v-if="oidcUser">
        <span>您好，{{ Name }}&nbsp;&nbsp;&nbsp;{{ position }}</span
        ><a href="javascript:;" @click="signOutOidc" class="logout">退出</a>
      </div>
      <ul class="header_nav">
        <HeaderTabItem path="/workflow/index">
          <div slot="item-text">网站首页</div>
        </HeaderTabItem>
        <HeaderTabItem path="/workflow/appall">
          <div slot="item-text">服务中心</div>
        </HeaderTabItem>
        <HeaderTabItem path="/workflow/todo">
          <div slot="item-text">
            <el-badge :value="dataLength['todo']" :max="99" class="item">
              个人中心
            </el-badge>
          </div>
        </HeaderTabItem>
      </ul>
    </div>
    <div class="header_logo">
      <div class="layout">
        <p class="header_p_logo"><Logo /></p>
        <Sraech />
      </div>
    </div>
    <div class="vertical_menu">
      <dl class="vertical_nav">
        <a @click="toTop">
          <dt><img src="@/assets/todoCenter/default/workflow/images/fhdb.png" alt=""></dt>
          <dd>返回顶部</dd>
        </a>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Sraech from "../modules/Search";
import HeaderTabItem from "../modules/HeaderTabItem";
import Logo from "@/components/todoCenter/logo";
export default {
  name: "",
  data() {
    return {
      userName: "",
      account: "",
      position:''
    };
  },
  components: {
    Sraech,
    HeaderTabItem,
    Logo,
  },
  watch:{
    getPositionsMes:{
      deep:true,
      handler(oldV){
        if (oldV && oldV.length > 0){
           this.$nextTick(()=>{
             this.isShowPosition(oldV);
           })
        }
      }
    },
    getUserInfo:{
      deep:true,
      handler(oldV){
        if (oldV){
          this.$store.dispatch('manageApp/getPositionsMes',oldV.id);
        }
      }
    },
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    dataLength() {
      return this.$store.getters.getDataLength;
    },
    Name() {
      return this.$store.getters.getUserInfo.name;
    },
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    },
    getPositionsMes(){
      return this.$store.getters['manageApp/getPositionsMes'];
    }
  },

  methods: {
    ...mapActions("oidcStore", ["signOutOidc"]),
    toTop(){
      document.body.scrollIntoView({behavior: "smooth"});
    },
    isShowPosition(val){
      let student = val.filter(item =>item.post.code == 'c812ee29-8f19-3c6c-85f9-0942f5ab25af' || item.post.code == 'cbbe5096-7b9a-3b8b-bca3-de2e49dd3bc5' || item.post.code == '032895e7-2472-3dcd-8b49-c2745df34c30' || item.post.code == 'c8a84451-e364-359b-b90c-36fd04dd979a');
      let teacher = val.filter(item => item.post.code == 'e7b50c93-3059-33aa-94d8-e31b1f406277');
      if (student && student.length > 0){
        this.position = '同学';
      }else if (teacher && teacher.length > 0){
        this.position = '老师';
      }else {
        this.position = '';
      }
    }
  },
};
</script>
<style>
/*
** 回到顶部
*/
.vertical_menu {
  position: fixed;
  bottom: 150px;
  right: 0;
  display: block;
  z-index: 999;
  overflow: hidden;
}

.vertical_menu .vertical_nav {
  width: 70px;
  text-align: center;
}

.vertical_menu .vertical_nav a {
  display: block;
  height: 70px;
  border-radius: 8px;
  padding-top: 10px;
  background: darkred;
}

.vertical_menu .vertical_nav a dt img {
  width: 25px;
}

.vertical_menu .vertical_nav a dd {
  margin-top: 10px;
  color: #FFFFFF;
  font-size: 12px;
}

.fix_position{
  position: fixed;
  width: 100% !important;
  z-index: 999 !important;
  padding-right: 20% !important;
  background: #700005;
}
.header_nav{
  margin-bottom: 0;
}
.header_nav .el-badge__content.is-fixed {
  position: absolute;
  top: 16px;
  right: -5px;
  transform: translateY(-50%) translateX(100%);
}
.header_nav .el-badge__content {
  background-color: #ffd400;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ffd400;
}
</style>
<style scoped>
.active {
  border-bottom: 3px #ffd400 solid;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/Header.vue